import { getUserToken } from './utils/authToken.js'

 //const URL = "http://localhost:4000"
const URL = "https://dsbackend.onrender.com"



//Date Calls

export const datesLoader = async () => {
    try {
        let dates = await fetch(URL + "/dates", {
            method: "GET",
            headers: {
                'Authorization': `bearer ${getUserToken()}`,
                'Content-Type': 'application/json'
            }
        })
        const parsedDates = await dates.json()
        return parsedDates
    } catch(err) {
        console.log(err)
        return[]
    }
}

export const dateLoader = async (id) => {
    try {
        let date = await fetch(URL + `/dates/${id}`, {
            method: "GET",
            headers: {
                'Authorization': `bearer ${getUserToken()}`,
                'Content-Type': 'application/json'
            }
        })
        date = await date.json()
        return date
    } catch(err) {
        console.log(err)
        return{}
    }
}

export const postDate = async (object) => {
    try {
        let newObject = {
            name: object.name,
            date: object.date,
            time: object.time,
            location: object.location,
            details: object.details,
            dateName: object.dateName,
            dateImage: object.dateImage,
            //idea: object.idea  Logic needs to be sorted out first
        }
        
        await fetch(URL + '/dates', {
            method: 'POST',
            headers: {
                'Authorization': `bearer ${getUserToken()}`,
                "Content-Type": "application/json"
            },
            body: JSON.stringify(newObject)
        })
    } catch (err) {
        console.log(err)
    }
}

export const putDate = async (object, id) => {
    try {
        let updatedObject = {
            name: object.name,
            date: object.date, //Date and Time will need to be parsed from forms when they are built
            time: object.time,
            location: object.location,
            details: object.details,
            dateName: object.dateName,
            dateImage: object.dateImage,
            idea: object.idea
        }

        await fetch(URL + `/dates/${id}`, {
            method: 'PUT',
            headers: {
                "Authorization": `bearer ${getUserToken()}`,
                "Content-Type": "application/json"
            },
            body: JSON.stringify(updatedObject)
        })
    } catch (err) {
        console.log(err)
    }
}

export const deleteDate = async (id) => {
    try {
        await fetch(URL + `/dates/${id}`, {
            method: 'DELETE',
            headers: {
                'Authorization': `bearer ${getUserToken()}`,
                "Content-Type": "application/json"
            }
        })
    } catch(err) {
        console.log(err)
    }
}

//Idea calls

export const ideasLoader = async () => {
    try {
        let ideas = await fetch(URL + "/ideas", {
            method: "GET",
            headers: {
                'Authorization': `bearer ${getUserToken()}`,
                'Content-Type': 'application/json'
            }
        })
        ideas = await ideas.json()
        return ideas
    } catch(err) {
        console.log(err)
        return[]
    }
}

export const ideaLoader = async (id) => {
    try {
        let idea = await fetch(URL + `/ideas/${id}`, {
            method: "GET",
            headers: {
                'Authorization': `bearer ${getUserToken()}`,
                'Content-Type': 'application/json'
            }
        })
        idea = await idea.json()
        return idea
    } catch(err) {
        console.log(err)
        return{}
    }
}

export const postIdea = async (object) => {
    try {
        let newObject = {
            name: object.name,
            location: object.location,
            details: object.details
        }
        
        await fetch(URL + '/ideas', {
            method: 'POST',
            headers: {
                'Authorization': `bearer ${getUserToken()}`,
                "Content-Type": "application/json"
            },
            body: JSON.stringify(newObject)
        })
    } catch (err) {
        console.log(err)
    }
}

export const putIdea = async (object, id) => {
    try {
        let updatedObject = {
            name: object.name,
            location: object.location,
            details: object.details
        }

        await fetch(URL + `/ideas/${id}`, {
            method: 'PUT',
            headers: {
                "Authorization": `bearer ${getUserToken()}`,
                "Content-Type": "application/json"
            },
            body: JSON.stringify(updatedObject)
        })
    } catch (err) {
        console.log(err)
    }
}

export const deleteIdea = async (id) => {
    try {
        await fetch(URL + `/ideas/${id}`, {
            method: 'DELETE',
            headers: {
                'Authorization': `bearer ${getUserToken}`
            }
        })
    } catch(err) {
        console.log(err)
    }
}

//Deck Calls

export const decksLoader = async () => {
    try {
        let decks = await fetch(URL + "/decks", {
            method: "GET",
            headers: {
                'Authorization': `bearer ${getUserToken()}`,
                'Content-Type': 'application/json'
            }
        })
        decks = await decks.json()
        return decks
    } catch(err) {
        console.log(err)
        return[]
    }
}

export const deckLoader = async (id) => {
    try {
        let deck = await fetch(URL + `/decks/${id}`, {
            method: "GET",
            headers: {
                'Authorization': `bearer ${getUserToken()}`,
                'Content-Type': 'application/json'
            }
        })
        deck = await deck.json()
        return deck
    } catch(err) {
        console.log(err)
    }
}

export const deckIdeasLoader = async (id) => {
    try {
        let deckIdeas = await fetch(URL + `/decks/${id}/ideas`, {
            method: "GET",
            headers: {
                'Authorization': `bearer ${getUserToken()}`,
                'Content-Type': 'application/json'
            }
        })
        deckIdeas = await deckIdeas.json()
        return deckIdeas
    } catch(err) {
        console.log(err)
    }
}

export const postDeck = async (object) => {
    try {
        let newObject = {
            name: object.name
        }
        
        await fetch(URL + '/decks', {
            method: 'POST',
            headers: {
                'Authorization': `bearer ${getUserToken()}`,
                "Content-Type": "application/json"
            },
            body: JSON.stringify(newObject)
        })
    } catch (err) {
        console.log(err)
    }
}

export const putDeck = async (object) => {
    try {
        let updatedObject = {
            name: object.name,
            ideas: object.ideas
        }

        await fetch(URL + `/decks/${object._id}`, {
            method: 'PUT',
            headers: {
                "Authorization": `bearer ${getUserToken()}`,
                "Content-Type": "application/json"
            },
            body: JSON.stringify(updatedObject)
        })
    } catch (err) {
        console.log(err)
    }
}

export const addIdeaToDeck = async (deck, idea) => {
    try {
        let ideaObject = {
            idea: idea
        }
        await fetch(URL + `/decks/${deck}/addIdea`, {
            method: 'PUT',
            headers: {
                "Authorization": `bearer ${getUserToken()}`,
                "Content-Type": "application/json"
            },
            body: JSON.stringify(ideaObject)
        })
    } catch (err) {
        console.log(err)
    }
}

export const removeIdeaFromDeck = async (idea, deck) => {
    try { 
            let ideaObject = {}
            ideaObject.idea = idea

        await fetch(URL + `/decks/${deck}/removeIdea`, {
            method: 'PUT',
            headers: {
                "Authorization": `bearer ${getUserToken()}`,
                "Content-Type": "application/json"
            },
            body: JSON.stringify(ideaObject)
        })
    } catch (err) {
        console.log(err)
    }
}

export const deleteDeck = async (id) => {
    try {
        await fetch(URL + `/ideas/${id}`, {
            method: 'DELETE',
            headers: {
                'Authorization': `bearer ${getUserToken}`
            }
        })
    } catch(err) {
        console.log(err)
    }
}


//Ratings Calls

export const ratingLoader = async (id) => {
    try {
        let rating = await fetch(URL + `/ratings/${id}`, {
            method: 'GET',
            headers: {
                'Authorization': `bearer ${getUserToken()}`,
                'Content-Type': 'application/json'
            }
        })
        rating = await rating.json()
        return rating
    } catch(err) {
        console.log(err)
    }
}

export const ratingsLoader = async () => {
    try {
        let ratings = await fetch(URL + `/ratings`, {
            method: 'GET',
            headers: {
                'Authorization': `bearer ${getUserToken()}`,
                'Content-Type': 'application/json'
            }
        })
        ratings = await ratings.json()
        return ratings
    } catch(err) {
        console.log(err)
    }
}

export const checkForRating = async (idea) => {
    try {
        let rating = await fetch(URL + `/ratings/checkRating/${idea}`, {
            method: 'GET',
            headers: {
                'Authorization': `bearer ${getUserToken()}`,
                'Content-Type': 'application/json'
            }
        })
        rating = await rating.json()
        return rating
    } catch(err) {
        console.log(err)
    }
}

export const postRating = async (object) => {
    try {
        await fetch(URL +'/ratings', {
            method: 'POST',
            headers: {
                'Authorization': `bearer ${getUserToken()}`,
                "Content-Type": "application/json"
            },
            body: JSON.stringify(object)
        })
    } catch(err) {
        console.log(err)
    }
}

export const editRating = async (id, object) => {
    try {
        await fetch(URL +`/ratings/${id}`, {
            method: 'PUT',
            headers: {
                'Authorization': `bearer ${getUserToken()}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(object)
        })
    } catch(err) {
        console.log(err)
    }
}